import React, { useRef, useState } from 'react';
import './Login.css';
import Header from '../inc/Header';
import { Link, useNavigate } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import GoogleButton from 'react-google-button';
import { useUserAuth } from '../../contexts/UserAuthContext';
import { collection, getDocs, getDoc, addDoc } from "firebase/firestore";
import { db } from '../../firebase'
import Signup from './Signup';

function Login(props) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const { logIn, googleSignIn, user } = useUserAuth();
  const [error, setError] = useState("")
  const navigate = useNavigate()
  const userCollectionRef = collection(db, "newusers")

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("")
    try {
      await logIn(email, password)
      window.location.reload()
      navigate("/")
      // if(!user.emailVerified){
      //   alert("Please Verify Your Email First")
      // }



    } catch (err) {
      setError(err.message)
    }
  }

  const handleGoogleSignIn = async (e) => {
    e.preventDefault()
    try {
      if (await googleSignIn()) {
        window.location.reload()
        navigate("/")
      }

      // const newUser = {
      //   "fullname": user.displayName,
      //    "email":user.email,
      //    "mobile":null,
      //    "password":null,
      //  }
      //  addDoc(userCollectionRef, newUser)



    } catch (err) {
      setError(err.message)
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <form onSubmit={handleSubmit} className="loog">


       

        <br />
        <br />

        <div className="album py-3">

          <div className="container">


            <div className="row justify-content-center">

              <div className="col-md-5">
                <div className="d-flex justify-content-between">

                  <Link to="/Signup">
                    <button className="signupbutton">Signup <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                    </svg></button>
                  </Link>
                </div>
                <br />
                <div className="card mb-4 ">

                  <div className="card-body">

                    {error && <Alert variant='danger'><center>{error}</center></Alert>}
              

                    <h5 className="card-text mb-3"><center>PROTHAMA
                    </center></h5>



                    <input onChange={(e) => setEmail(e.target.value)} type="text" className="form-control mb-3" placeholder="Email ID" required />



                    <input onChange={(e) => setPassword(e.target.value)} type="text" className="form-control mb-3" placeholder="Password" required />



                    <p className="card-text"> <center><small>{props.socialterm}</small></center> </p>

                    <div class="col-md-12 text-center">
                      <button type="submit" className="submit" style={{ width: '150px' }}>Submit </button>
                    </div>


                    <hr className='mb-2' />
                    <center>
                      <Link to="/Signup">Create your free account <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                        <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                      </svg></Link>
                    </center>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>


        <br />
        <br />
      </form>
    </>


  );
}

export default Login;